import React, { useEffect, useState } from 'react';
import { actions as screeningActions } from '../../redux/screeningActions';
import { Alert, Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { ReactSelect } from '../../../../common/components';

const ConditionSearch = ({ show, index, onFindCondition, onStartDeclaration }) => {
  const [condition, setCondition] = useState('');
  const [query, setQuery] = useState('');
  const [displayMinimum, setDisplayMinimum] = useState(false);

  const {
    conditions,
    hasMisspelledConditions,
    hasSurgicalProcedure,
    isSearching,
  } = useSelector((state) => state.screening);

  useEffect(
    () => {
      if (condition) {
        Promise.resolve(onStartDeclaration(condition)).finally(() => {
          setCondition('');
        });
      }
    },
    [condition, onStartDeclaration],
  );

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      searchCondition(query);
    }, 500); // Debounce time: 500 milliseconds

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [query]);

  if (!show) {
    return null;
  }
  const changeState = (condition) => {
    setCondition(condition);
  };

  const searchCondition = (query) => {
    if (query && query.length > 0 && query.length < 3) {
      setDisplayMinimum(true);
    } else {
      setDisplayMinimum(false);
    }
    onFindCondition(query);
  };

  const setSearchQuery = (query) =>{
    setQuery(query);
  };

  return (
    <div className="search-conditions form-horizontal">
      <FormGroup>
        {hasSurgicalProcedure ? (
          <Col xs={12}>
            <Alert bsStyle="danger">
              You have searched for a procedure or a surgery, please enter the name for
              the medical condition.
            </Alert>
          </Col>
        ) : null}
        {hasMisspelledConditions && (
          <Col xs={12}>
            <Alert bsStyle="danger">
              No medical condition was found matching your search. However, did you mean:
            </Alert>
          </Col>
        )}
        {displayMinimum && (
          <Col xs={12}>
            <Alert bsStyle="danger">
              A minimum of three letters are required for the search.
            </Alert>
          </Col>
        )}
        <Col sm={4} md={3}>
          <ControlLabel>Search conditions</ControlLabel>
        </Col>
        <Col sm={8} md={7} className="search-conditions-select">
          <ReactSelect
            placeholder="Enter Condition"
            name={'conditions-search-' + index}
            isLoading={isSearching}
            options={hasSurgicalProcedure ? [] : conditions}
            filterOptions={false}
            onInputChange={setSearchQuery}
            onChange={changeState}
            value={condition}
          />
        </Col>
      </FormGroup>
    </div>
  );
};

export default connect(
  null,
  {
    onStartDeclaration: screeningActions.startDeclaration,
    onFindCondition: screeningActions.findCondition,
  },
)(ConditionSearch);
